import React, { useEffect, useState } from "react";
import 'common/css/master.css';
import { toast, ToastContainer } from 'react-toastify';
import { PDFViewer } from '@react-pdf/renderer';

// questionPaperGenerator module ka proven PDF component reuse kar rahe hain � raw generate
// response (result.sections) seedha leta hai, koi mapping nahi chahiye, aur General Instructions
// + Section format + Ques. N [marks] format sab already sahi implement hai wahan.
import QuestionPaperPdf from '../../questionPaperGenerator/questionPaperPdf';

const QuestionPaperPdfSlider = (props) => {
    const { examId, syllabusId, subjectId, examName, examDuration, examMaxMarks, examSubject, generatedSets, closeSlider } = props;

    const [selectedSetIdx, setSelectedSetIdx] = useState(0);

    useEffect(() => {
        // console.log("QuestionPaperPdfSlider called, generatedSets", generatedSets);
        setSelectedSetIdx(0);
        if (!generatedSets || !generatedSets.length) {
            toast.warn("Please generate the question paper first");
        }
    }, [examId, syllabusId, subjectId, generatedSets]);

    const currentSet = generatedSets && generatedSets[selectedSetIdx];

    return (
        <div className="col-xs-12 col-centered padding-remove ">
            <ToastContainer autoClose={3000} hideProgressBar />
            <div>
                <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
                </button>
                {
                    generatedSets && generatedSets.length > 0 &&
                    <div className='col-sm-12 padding-remove' style={{ margin: "10px 0", display: "flex", gap: "8px" }}>
                        {generatedSets.map((set, idx) => (
                            <button
                                type="button"
                                key={set.setNo}
                                className="btn"
                                onClick={() => setSelectedSetIdx(idx)}
                                style={{
                                    padding: "6px 16px",
                                    borderRadius: "20px",
                                    border: idx === selectedSetIdx ? "2px solid #3200FF" : "1px solid #ccc",
                                    background: idx === selectedSetIdx ? "#3200FF" : "#fff",
                                    color: idx === selectedSetIdx ? "#fff" : "#333",
                                }}
                            >
                                {"Set " + set.setNo}
                            </button>
                        ))}
                    </div>
                }
                <div className='col-sm-12 padding-remove' style={{ margin: 0 }}>
                    {
                        currentSet ?
                            <PDFViewer style={{ width: "100%", height: "98vh", overflowY: "scroll" }}>
                                <QuestionPaperPdf
                                    result={currentSet}
                                    cls={currentSet.cls}
                                    subject={currentSet.subject}
                                    title={examName}
                                    setNo={currentSet.setNo}
                                    duration={examDuration}
                                    maxMarks={examMaxMarks}
                                />
                            </PDFViewer>
                            : null
                    }
                </div>
            </div>
        </div>
    );
}

export default QuestionPaperPdfSlider;
